import { render, staticRenderFns } from "./sub-contact.vue?vue&type=template&id=49e8677d&scoped=true"
import script from "./sub-contact.vue?vue&type=script&lang=js"
export * from "./sub-contact.vue?vue&type=script&lang=js"
import style0 from "./sub-contact.vue?vue&type=style&index=0&id=49e8677d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8677d",
  null
  
)

export default component.exports